// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Papa from "papaparse";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const CompatibleSlider = ({ currentStyle, url, path }) => {
//   const [data, setData] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchCSV = async () => {
//       try {
//         console.log(currentStyle, url, path)
//         // ✅ Add timestamp to bypass cache + force no-store
//         const response = await fetch(`${url}`, {
//           cache: "no-store",
//         });
//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const csvText = await response.text();
//         const parsed = Papa.parse(csvText, {
//           header: true,
//           skipEmptyLines: true,
//         });
//         setData(parsed.data);
//       } catch (err) {
//         console.error("Error loading CSV:", err);
//       }
//     };
//     fetchCSV();
//   }, [url]);

//   const clean = (value) => value?.trim().toLowerCase();

//   const currentItem = data.find(
//     (item) =>
//       clean(item.Style) === clean(currentStyle) ||
//       clean(item["Style#"]) === clean(currentStyle) ||
//       item.Handle?.startsWith(currentStyle)
//   );

//   if (!currentItem || !currentItem.companion) return null;

//   const companionStyles = currentItem.companion
//     .split("|")
//     .map((s) => s.trim())
//     .filter(Boolean);

//   // ✅ Use a Map to guarantee uniqueness
//   const uniqueItemsMap = new Map();

//   companionStyles.forEach((style) => {
//     const match = data.find(
//       (item) =>
//         clean(item.Style) === clean(style) ||
//         clean(item["Style#"]) === clean(style) ||
//         item.Handle?.startsWith(style)
//     );

//     const isSameAsCurrent =
//       clean(match?.Style) === clean(currentStyle) ||
//       clean(match?.["Style#"]) === clean(currentStyle) ||
//       match?.Handle?.startsWith(currentStyle);

//     if (match && !isSameAsCurrent) {
//       const key = clean(match.Style || match["Style#"] || match.Handle);
//       if (!uniqueItemsMap.has(key)) {
//         uniqueItemsMap.set(key, match);
//       }
//     }
//   });

//   const compatibleItems = Array.from(uniqueItemsMap.values());

//   if (compatibleItems.length === 0) return null;

  
//   const settings = {
//     dots: true,
//     infinite: compatibleItems.length > 1,
//     speed: 1000,
//     autoplay: compatibleItems.length > 1,
//     autoplaySpeed: 2000,
//     slidesToShow: Math.min(compatibleItems.length, 3),
//     slidesToScroll: 1,
//     arrows: compatibleItems.length > 1,
//     responsive: [{ breakpoint: 768, settings: { slidesToShow: 1 } }],
//   };

//   return (
//     <div style={{ margin: "2rem 0" }}>
//       <hr />
//       <h4>You may also like</h4>
//       <Slider {...settings}>
//         {compatibleItems.map((item, idx) => (
//           <div
//             key={item.Style || item["Style#"] || idx}
//             onClick={() =>
//               (window.location.href = `/${path}/${
//                 item.Style || item["Style#"]
//               }`)
//             }
//             style={{
//               cursor: "pointer",
//               textAlign: "center",
//               padding: "10px",
//             }}
//           >
//             <img
//               src={
//                 item.FRONT_MODEL ||
//                 item.BACK_MODEL ||
//                 item.FRONT_FLAT ||
//                 item.BACK_FLAT ||
//                 item.front ||
//                 item.back ||
//                 "/images/placeholder.jpg"
//               }
//               alt={item.Style || "Compatible Item"}
//               style={{
//                 width: "150px",
//                 borderRadius: "10px",
//                 margin: "0 auto",
//               }}
//               onError={(e) => {
//                 e.target.src = "/images/placeholder.jpg";
//               }}
//             />
//             <h6>{item.Style || item["Style#"]}</h6>
//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default CompatibleSlider;


import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { collection, getDocs } from "firebase/firestore";
import { productDb } from "../firebaseProducts";
import "../CompatibleSlider.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

const CompatibleSlider = ({ currentStyle, path }) => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let collectionName = "";

        if (path === "product") {
          collectionName = "kids-apparel";
        } else if (path === "product-adult") {
          collectionName = "adult-apparel";
        } else {
          console.warn("Unknown path:", path);
          return;
        }

        const snapshot = await getDocs(collection(productDb, collectionName));

        const items = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setData(items);
      } catch (err) {
        console.error("Firestore error:", err);
      }
    };

    fetchData();
  }, [path]);

  const clean = (val) => val?.toString().trim().toLowerCase();

  // ✅ IMPORTANT: reduce duplicates (same style, different sizes)
  const uniqueByStyle = useMemo(() => {
    const map = new Map();

    data.forEach((item) => {
      const key = clean(item.Style || item["Style#"]);
      if (key && !map.has(key)) {
        map.set(key, item);
      }
    });

    return Array.from(map.values());
  }, [data]);

  // ✅ Find current item
  const currentItem = uniqueByStyle.find(
    (item) =>
      clean(item.Style) === clean(currentStyle) ||
      clean(item["Style#"]) === clean(currentStyle) ||
      item.Handle?.startsWith(currentStyle)
  );

  if (!currentItem || !currentItem.companion) return null;

  const companionStyles = currentItem.companion
    .split("|")
    .map((s) => s.trim())
    .filter(Boolean);
// console.log(companionStyles)
  // ✅ Find companions
const compatibleItems = uniqueByStyle.filter((item) => {
  const itemStyle = clean(item.Style || item["Style#"]);
  const itemHandle = clean(item.Handle);

  return companionStyles.some((style) => {
    const s = clean(style);

    return (
      itemStyle === s ||
      itemStyle?.includes(s) ||
      itemHandle?.includes(s)
    );
  });
}).filter((item) => {
  const isSame =
    clean(item.Style) === clean(currentStyle) ||
    clean(item["Style#"]) === clean(currentStyle);

  return !isSame;
});
  if (compatibleItems.length === 0) return null;

  const settings = {
    dots: true,
    infinite: compatibleItems.length > 1,
    speed: 800,
    autoplay: compatibleItems.length > 1,
    autoplaySpeed: 2500,
    slidesToShow: Math.min(compatibleItems.length, 3),
    slidesToScroll: 1,
    arrows: compatibleItems.length > 1,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div style={{ margin: "2rem 0" }}>
      <hr />
      <h4>You may also like</h4>
<div className="sliderWrapper">
      <Slider {...settings}>
        {compatibleItems.map((item, idx) => (
          <div
            key={item.id || idx}
            onClick={() =>{
               const style = item.Style || item["Style#"];
  Link(`/${path}/${style}`);
            }
            }
            style={{
              cursor: "pointer",
              textAlign: "center",
              padding: "10px",
            }}
          >
            <img
              src={
                item.FRONT_MODEL ||
                item.BACK_MODEL ||
                item.FRONT_FLAT ||
                item.BACK_FLAT ||
                item.front ||
                item.back ||
                "/images/placeholder.jpg"
              }
              alt={item.Style}
              style={{
                width: "140px",
                borderRadius: "10px",
                margin: "0 auto",
              }}
              onError={(e) => {
                e.target.src = "/images/placeholder.jpg";
              }}
            />

            <h6>{item.Style}</h6>
          </div>
        ))}
      </Slider>
      </div>
    </div>
  );
};

export default CompatibleSlider;